import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { shareReplay, switchMap } from 'rxjs/operators';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { CommonThemeState } from '@nimbus-library/features/shared/store/theme-store/common-theme.state';
import { ChartTheme } from '@nimbus-library/features/charts/models/char-theme.enum';

@Injectable({
  providedIn: 'root',
})
export class SpinnerService {
  private readonly lightSpinnerPath: string = '/animations/spinner/light-spinner.json';
  private readonly darkSpinnerPath = '/animations/spinner/dark-spinner.json';
  private readonly nimbusSpinnerPath = '/animations/spinner/nimbus-spinner.json';

  private readonly lightSpinner$ = this.httpClient.get(this.lightSpinnerPath).pipe(shareReplay(1));
  private readonly darkSpinner$ = this.httpClient.get(this.darkSpinnerPath).pipe(shareReplay(1));
  private readonly nimbusSpinner$ = this.httpClient.get(this.nimbusSpinnerPath).pipe(shareReplay(1));

  public constructor(
    private readonly httpClient: HttpClient,
    private readonly store: Store,
  ) {}

  public getSpinner$(small: boolean = false): Observable<object> {
    return small ? this.getSmallSpinner$() : this.nimbusSpinner$;
  }

  private getSmallSpinner$(): Observable<object> {
    return this.store.select(CommonThemeState.theme).pipe(
      switchMap((theme) => {
        if (theme === ChartTheme.Light) {
          return this.darkSpinner$;
        } else {
          return this.lightSpinner$;
        }
      }),
    );
  }
}
